import {NextPage} from "next";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {wrapper} from "../app/store";
import {OrderListView} from "../components/orderList/OrderListView";
import Head from "next/head";
import React from "react";

const Orders: NextPage = () => {
  return <>
    <Head>
      <title>{`Past Orders`}</title>
      <meta property="og:url" key="og:url" content={`${process.env.NEXT_PUBLIC_APP_DOMAIN_URL}/orders`}/>
      <meta property="og:title" key="og:title" content={`Past Orders`} />
      <meta property="twitter:title" key="twitter:title" content={`Past Orders`} />
    </Head>
    <OrderListView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  const metaTitle = 'Past Orders'
  const metaUrl = `${process.env.NEXT_PUBLIC_APP_DOMAIN_URL}/orders`

  return {
    props: {
      metaTags: [
        {
          property: 'og:title',
          content: metaTitle
        },
        {
          property: 'twitter:title',
          content: metaTitle
        },
        {
          property: 'og:url',
          content: metaUrl
        }
      ],
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order']),
    }
  }
});

export default Orders